<template>
  <div id="pageRoot">
    <!-- TEXT ----------------------------------------------------------------------------------------------------->
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />
    <!-- TEXT ----------------------------------------------------------------------------------------------------->

    <div id="fridge" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage61Fridge.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>
    <div id="roof" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage64Roof.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>
    <div id="balcony" class="basicItem01">
      <img
        src="/pages/img/sordo/svgPage61Balcony.svg"
        class="pageElement"
        style="width: 100%; height: 100%"
      />
    </div>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <span class="footer-page footer-write"></span>
    <div class="pageSVG">
      <img
        src="/pages/img/sordo/svgPage61.svg"
        class="pageElement"
        style="width: 100%; height: auto"
      />
    </div>
    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
#fridge {
  position: absolute;
  left: 77.25%;
  right: 9.93%;
  top: 5.86%;
  bottom: 70.29%;
}
#roof {
  position: absolute;
  left: 73.73%;
  right: 6.39%;
  top: 35.03%;
  bottom: 48.13%;
}
#balcony {
  position: absolute;
  left: 73.83%;
  right: 2.56%;
  top: 51.82%;
  bottom: 26.39%;
}
#inputField01 {
  width: 430px;
  margin-left: 29%;
  margin-top: 8%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
}
#inputField02 {
  width: 430px;
  margin-left: 29%;
  margin-top: 25.2%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
}
#inputField03 {
  width: 430px;
  margin-left: 29%;
  margin-top: 42.3%;
  font-size: 45px;
  position: absolute;
  z-index: 3;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p61/V31.mp4", "p61/V32.mp4", "p61/V33.mp4"],
    };
  },
};
</script>